const moment = require('moment');

export const comparacion = () => {
    return {
        id: null,
        id_empresa: null,
        id_ubicacion: null,
        fecha: moment().format('yyyy-MM-DD'),
        matriz_compatibilidad_productos: []
    };
};

export const filtros = () => {
    return {
        page: 1,
        perPage: 10,
        sortBy: 'id',
        sort: 'DESC',
        id_empresa: null,
        id_ubicacion: null
    };
};

export const filtrosProductos = () => {
    return {
        page: 1,
        perPage: 5,
        sortBy: 'id',
        sort: 'DESC',
        filtro: '',
        id_empresa: null,
        id_ubicacion: null,
        id_fabricante: null,
        mostrar_todos: false
    };
};

export default {
    comparacion: comparacion(),
    comparaciones: {
        data: []
    },
    productos: {
        data: []
    },
    ubicacion: '',
    productos_seleccionados: [],
    filtros: filtros(),
    filtros_productos: filtrosProductos(),
    accion: 'Crear',
    resultado: null,
    fabricantes: [],
    empresas_filtro: [],
    empresas: [],
    ubicaciones: [],
    seleccionar_todos: {
        valor: false
    },
    ubicaciones_filtro: []
};
